import i18n from 'i18next';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetEquipmentTypes } from '../../hooks';

// TODO: investigate if it is related to common or only to shipment
export const EquipmentTypeSelect = ({
  placeholder = i18n.t('translation:default.fields.equipmentType.placeholder'),
  label = i18n.t('translation:default.fields.equipmentType.label'),
  rules = [],
  name,
  margin,
  editMode,
  onChange,
  tooltip,
  isDefault = false,
}) => {
  const { data: options = [], isLoading } = useGetEquipmentTypes();

  return (
    <FormSelectBox
      loading={isLoading}
      options={
        isDefault === true
          ? [{ label: i18n.t('translation:default.buttons.select'), value: '' }, ...options]
          : [{ label: i18n.t('translation:default.options.all'), value: -1 }, ...options]
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      tooltip={tooltip}
    />
  );
};
